<template>
  <div class="paygame-tab">
    <a
      class="tab"
      :class="{ tabActive: $route.path.indexOf('/paygame') > -1 &&  $route.path.indexOf('/paygame_history') === -1}"
      href="/paygame/"
      >{{ $t("paygame.gamepay") }}</a
    >
    <a
      class="tab"
      :class="{ tabActive: $route.path.indexOf('/paygame_history') > -1 }"
      href="/paygame_history/"
      >{{ $t("paygame.payHistory") }}</a
    >
  </div>
</template>

<script>
export default {
  created() {},
};
</script>

<style lang="scss">
.paygame-tab {
  width: 1200px;
  margin: 0 auto;
  padding-top: 80px;
  padding-bottom: 20px;
  text-align: center;
  border-bottom: 1px solid #ebebeb;
  a {
    position: relative;
    text-decoration: none;
    font-size: 20px;
    letter-spacing: 0;
  }
  .tab {
    color: #b5b5b5;
    &:hover {
      color: #3b3b3b;
      &::after {
        content: "";
        @extend %Center;
        top: 40px;
        width: 32px;
        height: 6px;
        background: #2da2d4;
        border-radius: 3px;
      }
    }
  }
  .tab:first-child {
    margin-right: 400px;
  }
  .tabActive {
    color: #3b3b3b;
    &::after {
      content: "";
      @extend %Center;
      top: 40px;
      width: 32px;
      height: 6px;
      background: #2da2d4;
      border-radius: 3px;
    }
  }
}
</style>
